/**
 * What Pro costs. One place for the number, read by the plan page, the payment dialogs, the
 * landing page and the server that credits payments (netlify/functions/api/pay.ts),
 * so a change here is the change everywhere.
 *
 * Pro is paid in USDC on Solana: one credit is one month, bought one, three, six or twelve at a
 * time at the same price a month. The list price is what the discount is taken from.
 */

/** A month of Pro, in USDC */
export const PRO_MONTHLY_USDC = 5;
/** The price a month of Pro is discounted from, in USDC */
export const PRO_LIST_USDC = 18;
/** The discount, as a whole percentage (72 for 5 of 18) */
export const PRO_DISCOUNT_PERCENT = Math.round((1 - PRO_MONTHLY_USDC / PRO_LIST_USDC) * 100);

export interface CreditPackage {
    credits: number;
    label: string;
    /** What it costs, in USDC */
    price: number;
    /** What it would cost at the list price, in USDC */
    listPrice: number;
    popular?: boolean;
    best?: boolean;
}

const months = (credits: number, label: string, extra: Partial<CreditPackage> = {}): CreditPackage => ({
    credits, label, price: credits * PRO_MONTHLY_USDC, listPrice: credits * PRO_LIST_USDC, ...extra,
});

/** The amounts offered: a month, a quarter, half a year, a year */
export const CREDIT_PACKAGES: CreditPackage[] = [
    months(1, '1 month'),
    months(3, '3 months'),
    months(6, '6 months', { popular: true }),
    months(12, '1 year', { best: true }),
];

/** "5 USDC", "0.50 USDC" */
export const formatUsdc = (amount: number): string => `${Number.isInteger(amount) ? amount : amount.toFixed(2)} USDC`;
